import { MONTHS_TR } from "@/lib/finance";
import { useState } from "react";
import { ChevronLeft, ChevronRight, Calendar } from "lucide-react";

export default function MonthPicker({ year, month, onChange, testId = "month-picker" }) {
  const [open, setOpen] = useState(false);
  const shift = (delta) => {
    let m = month + delta, y = year;
    while (m > 12) { m -= 12; y += 1; }
    while (m < 1) { m += 12; y -= 1; }
    onChange(y, m);
  };
  return (
    <div className="relative" data-testid={testId}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="h-11 min-w-[220px] rounded-lg border border-slate-200 bg-white px-4 text-sm flex items-center justify-between gap-3 hover:border-slate-300 transition-colors"
      >
        <span className="flex items-center gap-2 text-slate-700"><Calendar size={15} className="text-slate-400" />{MONTHS_TR[month - 1]} {year}</span>
        <svg width="12" height="12" viewBox="0 0 12 12" className="text-slate-400"><path d="M2 4l4 4 4-4" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/></svg>
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-10" onClick={() => setOpen(false)} />
          <div className="absolute right-0 z-20 mt-2 w-[280px] rounded-xl border border-slate-200 bg-white shadow-md p-3">
            <div className="flex items-center justify-between mb-3">
              <button type="button" onClick={() => onChange(year - 1, month)} className="p-1.5 rounded hover:bg-slate-100 text-slate-600"><ChevronLeft size={16} /></button>
              <div className="font-semibold text-slate-900">{year}</div>
              <button type="button" onClick={() => onChange(year + 1, month)} className="p-1.5 rounded hover:bg-slate-100 text-slate-600"><ChevronRight size={16} /></button>
            </div>
            <div className="grid grid-cols-3 gap-2">
              {MONTHS_TR.map((m, i) => {
                const active = (i + 1) === month;
                return (
                  <button
                    key={m}
                    type="button"
                    onClick={() => { onChange(year, i + 1); setOpen(false); }}
                    className={`h-9 rounded-md text-xs font-medium transition-colors ${
                      active ? "bg-emerald-800 text-white" : "bg-slate-50 text-slate-700 hover:bg-slate-100"
                    }`}
                  >
                    {m.slice(0, 3)}
                  </button>
                );
              })}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
